import axios from '@/utils/request'

const baseURL = process.env.VUE_APP_FILE_URL

export default {
    login: (data) => axios({ url: '/api/oauth/login', method: 'POST', data }), // 登陆
    getVerificationCode: (data) => axios({ url: '/api/store/open/verificationCode', method: 'POST', data }), // 发送验证码
    forgetPassword: (data) => axios({ url: '/api/store/open/forgetPassword', method: 'POST', data }), // 校验验证码
    editPassword: (data) => axios({ url: '/api/store/open/password', method: 'PUT', data }), // 修改密码
    logout: data => axios({ url: '/api/oauth/logout', data, method: 'PUT' }), // 登出

    getPublicSelectData: (params) => axios({ url: '/api/system/open/dropDownInfo', method: 'GET', params }), // 获取公共下拉
    signValue: (params) => axios({ url: '/api/system/signValue', method: 'GET', params }), // 获取阿里云文件服务器上传校验秘钥
    uploadFile: (data) => axios({ url: '/api/hbo/uploadFile', method: 'POST', data }), // 上传文件阿里云文件服务器
    uploadExcelFile: (data) => axios({ baseURL, url: '/api/hbo/uploadExcelFile', method: 'POST', data }), // 上传excel文件阿里云文件服务器
    uploadUniversalFile: (data) => axios({ baseURL, url: '/api/hbo/uploadUniversalFile', method: 'POST', data }), // 通用上传文件接口

    /**
     * 
     * @param { dictTypeCode } params dictTypeCode获取品类导入模板：data:categorydownloadtemplate 
     */
    getSystemImport: (params) => axios({ url: '/api/system/dictValue', method: 'GET', params }), // 获取数据字典 (文件导出)

    getCountryList: (params) => axios({ url: '/api/system/countryList', method: 'GET', params }), // 获取国家列表
    getPlatformSelect: params => axios({ url: '/api/store/allPlatform', params }), // 平台下拉框数据
    getStoreSelect: data => axios({ url: `/api/store/allStore`, method: 'post', data }), // 店铺下拉
    
    getWarehouseCountry: params => axios({ url: `/api/product/warehouseCountry`, method: 'get', params }), // 获取仓库下所有国家列表

    getExportFieldRecords: (type, params) => axios({ url: `/api/store/user/behaviorConfig/${type}`, method: 'GET', params }), // 获取用户行为信息根据type
    setExportFieldRecords: (data) => axios({ url: '/api/store/user/behaviorConfig', method: 'POST', data }), // 新增或编辑用户行为配置信息
}